import { Section } from 'src/app/components/Elements/Section';
import { Typography } from 'src/app/components/Elements/Typography';

import { IconsRow, IconTextContainer, ItemGrouping, StepsCol, StepsIcon, StepsIconPhone } from '../styles';

export const StepsSection = () => {
  return (
    <Section color="capsuleGreen00">
      <h2>Capsule is a full-service pharmacy.</h2>
      <IconsRow>
        <StepsCol lg="3">
          <ItemGrouping>
            <StepsIcon src="/public/branded_bag_with_hand.svg" />
            <IconTextContainer>
              <Typography variant="body">
                <b>Free same-day delivery</b>
              </Typography>
            </IconTextContainer>
          </ItemGrouping>
        </StepsCol>
        <StepsCol lg="3">
          <ItemGrouping>
            <StepsIcon src="/public/envelope.svg" />
            <IconTextContainer>
              <Typography variant="body">
                <b>We accept your insurance</b>
              </Typography>
            </IconTextContainer>
          </ItemGrouping>
        </StepsCol>
        <StepsCol lg="3">
          <ItemGrouping>
            <StepsIconPhone src="/public/Icon_Phone_App.svg" />
            <IconTextContainer>
              <Typography variant="body">
                <b>Order from home</b>
              </Typography>
            </IconTextContainer>
          </ItemGrouping>
        </StepsCol>
        <StepsCol lg="3">
          <ItemGrouping>
            <StepsIcon src="/public/message_icons.svg" />
            <IconTextContainer>
              <Typography variant="body">
                <b>Text or chat with pharmacists 7 days a week</b>
              </Typography>
            </IconTextContainer>
          </ItemGrouping>
        </StepsCol>
      </IconsRow>
    </Section>
  );
};
